import { render, staticRenderFns } from "./SalesRank.vue?vue&type=template&id=86698afa&scoped=true&"
import script from "./SalesRank.vue?vue&type=script&lang=js&"
export * from "./SalesRank.vue?vue&type=script&lang=js&"
import style0 from "./SalesRank.vue?vue&type=style&index=0&id=86698afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86698afa",
  null
  
)

export default component.exports